import { object, string, type InferType } from "yup";

export enum OtherPaymentPrefFormFields {
  Instructions = "instructions",
}

export const OtherPaymentPrefFormSchema = object().shape({
  [OtherPaymentPrefFormFields.Instructions]: string()
    .required("Please enter distribution payment instructions")
    .matches(/\S/, "Please enter distribution payment instructions"),
});

export type OtherPaymentPrefFormType = InferType<typeof OtherPaymentPrefFormSchema>;
